const i18n = require('@/i18n').default;

module.exports = {
    items: [
        {
            route: 'account.dashboard',
            hamburgerMenu: {
                icon: 'dashboard.png',
                label: i18n.t('DASHBOARD_DASHBOARD'),
                labelTranslateKey: 'DASHBOARD_DASHBOARD',
                order: 1,
                enabled: true,
                enabledForInactiveUser: true,
            },
        },
        {
            route: 'account.free-flowers',
            hamburgerMenu: {
                icon: 'free-boxes.svg',
                label: i18n.t('DASHBOARD_FREE_BOXES'),
                labelTranslateKey: 'DASHBOARD_FREE_BOXES',
                order: 2,
                enabled: true,
                enabledForInactiveUser: false,
            },
            dashboard: {
                image: 'free-flowers',
                label: i18n.t('DASHBOARD_SEND_A_FREE_BOX'),
                labelTranslateKey: 'DASHBOARD_SEND_A_FREE_BOX',
                counterGetterName: 'account/getUserInvitesRemaining',
                order: 1,
                enabled: true,
                enabledForInactiveUser: false,
            },
        },
        {
            route: 'account.rate-my-flowers',
            hamburgerMenu: {
                icon: 'rate-my-flowers.svg',
                label: i18n.t('DASHBOARD_RATE_MY_FLOWERS'),
                labelTranslateKey: 'DASHBOARD_RATE_MY_FLOWERS',
                order: 5,
                enabled: true,
                enabledForInactiveUser: false,
            },
            dashboard: {
                image: 'rate-my-flowers',
                label: i18n.t('DASHBOARD_RATE_YOUR_FLOWERS'),
                labelTranslateKey: 'DASHBOARD_RATE_YOUR_FLOWERS',
                order: 2,
                enabled: true,
                enabledForInactiveUser: false,
            },
        },
        {
            route: 'account.your-boxes',
            hamburgerMenu: {
                icon: 'your-boxes.svg',
                label: i18n.t('DASHBOARD_WHATS_IN_THE_BOX'),
                labelTranslateKey: 'DASHBOARD_WHATS_IN_THE_BOX',
                order: 3,
                enabled: true,
                enabledForInactiveUser: false,
            },
            dashboard: {
                image: 'your-boxes',
                label: i18n.t('DASHBOARD_WHATS_IN_THE_BOX'),
                labelTranslateKey: 'DASHBOARD_WHATS_IN_THE_BOX',
                order: 3,
                enabled: true,
                enabledForInactiveUser: false,
            },
        },
        {
            route: 'account.gifting',
            hamburgerMenu: {
                image: 'gift',
                icon: 'send-a-gift.svg',
                label: i18n.t('DASHBOARD_SEND_A_GIFT'),
                labelTranslateKey: 'DASHBOARD_SEND_A_GIFT',
                order: 4,
                enabled: process.env.VUE_APP_GIFTING_ENABLED === 'true',
                enabledForInactiveUser: false,
            },
            dashboard: {
                image: 'gift',
                label: i18n.t('DASHBOARD_SEND_A_GIFT'),
                labelTranslateKey: 'DASHBOARD_SEND_A_GIFT',
                order: 8,
                enabled: process.env.VUE_APP_GIFTING_ENABLED === 'true',
            },
        },
        {
            route: 'account.delivery-schedule',
            hamburgerMenu: {
                icon: 'delivery-schedule.svg',
                label: i18n.t('DASHBOARD_CALENDAR'),
                labelTranslateKey: 'DASHBOARD_CALENDAR',
                order: 6,
                enabled: true,
                enabledForInactiveUser: false,
            },
            dashboard: {
                image: 'upcoming-deliveries',
                label: i18n.t('DASHBOARD_CALENDAR'),
                labelTranslateKey: 'DASHBOARD_CALENDAR',
                order: 6,
                enabled: true,
                enabledForInactiveUser: false,
            },
        },
        {
            route: 'account.shop',
            hamburgerMenu: {
                icon: 'shop.svg',
                label: i18n.t('DASHBOARD_FREDDIES_SHOP'),
                labelTranslateKey: 'DASHBOARD_FREDDIES_SHOP',
                order: 6,
                enabled: true,
                enabledForInactiveUser: false,
            },
            dashboard: {
                image: 'shop',
                label: i18n.t('DASHBOARD_FREDDIES_SHOP'),
                labelTranslateKey: 'DASHBOARD_FREDDIES_SHOP',
                order: 2,
                enabled: true,
                enabledForInactiveUser: false,
            },
        },
        {
            route: 'account.order-a-vase',
            dashboard: {
                image: 'order-a-vase',
                label: i18n.t('DASHBOARD_FREDDIES_VASE'),
                labelTranslateKey: 'DASHBOARD_FREDDIES_VASE',
                order: 7,
                enabled: !(process.env.VUE_APP_SHOP_ENABLED === 'true'),
                enabledForInactiveUser: true,
            },
        },
        {
            route: 'account.delivery-addresses',
            hamburgerMenu: {
                icon: 'delivery-addresses.svg',
                label: i18n.t('DASHBOARD_DELIVERY_ADDRESSES'),
                labelTranslateKey: 'DASHBOARD_DELIVERY_ADDRESSES',
                order: 7,
                enabled: true,
                enabledForInactiveUser: true,
            },
            dashboard: {
                image: 'address',
                label: i18n.t('DASHBOARD_YOUR_ADDRESSES'),
                labelTranslateKey: 'DASHBOARD_YOUR_ADDRESSES',
                order: 5,
                enabled: true,
                enabledForInactiveUser: true,
            },
        },
        // {
        //     route: 'blog',
        //     target: '_blank',
        //     dashboard: {
        //         image: 'blog',
        //         label: i18n.t('DASHBOARD_FLOWER_BLOG'),
        //         labelTranslateKey: 'DASHBOARD_FLOWER_BLOG',
        //         order: 9,
        //         enabled: false,
        //     },
        // },
        {
            route: 'account.manage-account',
            hamburgerMenu: {
                icon: 'account.svg',
                label: i18n.t('DASHBOARD_YOUR_ACCOUNT'),
                labelTranslateKey: 'DASHBOARD_YOUR_ACCOUNT',
                order: 8,
                enabled: true,
                enabledForInactiveUser: true,
            },
            dashboard: {
                image: 'manage-account',
                label: i18n.t('DASHBOARD_YOUR_ACCOUNT_DETAILS'),
                labelTranslateKey: 'DASHBOARD_YOUR_ACCOUNT_DETAILS',
                order: 3,
                enabled: true,
                enabledForInactiveUser: true,
            },
        },
    ],
};
